import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {connectAppEnv} from '../../../app/app-env';
import {withUILevel} from '../../../lib/react/oe-higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import {UIControllerType} from '../../../react-oe/oe-types';
import {OEManualViewLinks} from '../../views/manual-view/oe-manual-view-model';
import OEPopover from '../../views/oe-popover';
import OEDropdown from '../../elements/controls/oe-dropdown';
import {OEGroupControl, OEControl, OEToggleCheckboxControl} from '../../elements/controls/oe-controls';
import {OEDefaultConfigFactory} from '../../oe-default-configs';
import retardUpdate from '../../../lib/react/update-retarder';
import {OEUserObjectGeometryType, OEUserObjectToolbox} from './oe-user-object-model';

export class OEUserObjectController extends React.PureComponent {

    constructor(props)  {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.geometryEntries = OEUserObjectToolbox.createGeometryTypeEntries();

        this.state = {
            uiEnabled: false,
            enabled: false,
            enableEdit: false,
            enableAddRemove: false,
            geometryType: OEUserObjectGeometryType.default,
            strings: {
                title: '',
                enable: '',
                editLabel: '',
                addRemoveLabel: '',
                geometryLabel: ''
            },
            geometryEntries: clone(this.geometryEntries)
        };

        this.updateLanguage = this.updateLanguage.bind(this);
        this.updateControlsState = this.updateControlsState.bind(this);
        this.onUserObjectAdded = this.onUserObjectAdded.bind(this);
        this.onUIControllerStateChanged = this.onUIControllerStateChanged.bind(this);

        this.onHelpBtnPressed = this.onHelpBtnPressed.bind(this);
        this.onEnableSwitchChanged = this.onEnableSwitchChanged.bind(this);
        this.onEditSwitchChanged = this.onEditSwitchChanged.bind(this);
        this.onAddRemoveSwitchChanged = this.onAddRemoveSwitchChanged.bind(this);
        this.onGeometrySelected = this.onGeometrySelected.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.userObjectsEnabledChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.userObjectEditModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.userObjectGeometryStateChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.userObjectAdded, this.onUserObjectAdded);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.userObjectsEnabledChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.userObjectEditModeChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.userObjectGeometryStateChanged, this.updateControlsState);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.userObjectAdded, this.onUserObjectAdded);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.uiControllerStateChanged, this.onUIControllerStateChanged);
    }

    updateLanguage()   {
        this.geometryEntries.forEach(entry => {
            entry.label = this.oe.sharedInterface.getLocalizedStringEnc('user_object_view_geometry_' + entry.key);
        });

        this.setState({
            strings: {
                title: this.oe.sharedInterface.getLocalizedStringEnc('user_object_view'),
                enable: this.oe.sharedInterface.getLocalizedStringEnc('user_object_view_enable'),
                editLabel: this.oe.sharedInterface.getLocalizedStringEnc('user_object_view_edit'),
                addRemoveLabel: this.oe.sharedInterface.getLocalizedStringEnc('user_object_view_add_remove'),
                geometryLabel: this.oe.sharedInterface.getLocalizedStringEnc('user_object_view_geometry')
            },
            geometryEntries: clone(this.geometryEntries)
        });
    }

    updateControlsState()   {
        let controller = this.oe.sharedInterface.getUIControllerUserObject();

        this.setState({
            enabled: controller.getEnabled(),
            enableEdit: controller.isEditingEnabled(),
            enableAddRemove: controller.isEditingAddRemoveEnabled(),
            geometryType: controller.getGeometryType().value
        });
    }

    updateUIState()   {
        this.setState({
            uiEnabled: this.oe.sharedInterface.getUIControllerUserObject().getUIEnabled()
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            this.setState({ uiEnabled: false });
            return;
        }

        retardUpdate(this, () => {
            this.updateLanguage();
            this.updateControlsState();
            this.updateUIState();
        });
    }

    onUserObjectAdded() {
        if(this.oe.sharedInterface.getUIControllerUserObject().isEditingEnabled()) {
            this.oe.sharedInterface.getUIControllerUserObject().enableEditingAddRemove(false);
        }
    }

    onUIControllerStateChanged(message, userInfo)    {
        if(userInfo.type === this.oe.Module.UIControllerType.user_object) {
            this.updateUIState();
        }
    }

    render()    {
        if(!this.props.config.enabled) return null;
        let disabledEditing = !(this.state.uiEnabled && this.state.enabled);
        let disabledAdd = !this.state.enableEdit || disabledEditing;
        let geometryEntries = this.state.geometryEntries.map(entry => { return {key: entry.type, content: <span className="label">{entry.label}</span>} } );

        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OEPopover
                    className="popover-control"
                    placement="right-start"
                    moduleId={this.props.moduleId}
                    uiControllerType={UIControllerType.user_object}
                    boundariesElement={this.props.boundariesElement}
                    target={this.props.target}
                    buttonClassName="transparent-btn"
                    title={this.state.strings.title}
                    onHelpBtnPressed={this.props.config.showHelpBtn ? this.onHelpBtnPressed : null}
                >
                    <div className="user-object-controller">
                        <OEGroupControl>
                            <OEToggleCheckboxControl
                                className="align-right"
                                title={this.state.strings.enable}
                                active={this.state.enabled}
                                disabled={!this.state.uiEnabled}
                                onClick={this.onEnableSwitchChanged}
                            />
                            <OEToggleCheckboxControl
                                className="align-right"
                                title={this.state.strings.editLabel}
                                active={this.state.enableEdit}
                                disabled={disabledEditing}
                                onClick={this.onEditSwitchChanged}
                            />
                            <OEToggleCheckboxControl
                                className="align-right"
                                title={this.state.strings.addRemoveLabel}
                                active={this.state.enableAddRemove}
                                disabled={disabledAdd}
                                onClick={this.onAddRemoveSwitchChanged}
                            />
                        </OEGroupControl>
                        <OEGroupControl title={this.state.strings.geometryLabel}>
                            <OEControl>
                                <OEDropdown
                                    title={this.state.geometryEntries[this.state.geometryType].label}
                                    disabled={!this.state.uiEnabled || !this.state.enableAddRemove}
                                    chosenKey={this.state.geometryType}
                                    entries={geometryEntries}
                                    onClick={this.onGeometrySelected}
                                />
                            </OEControl>
                        </OEGroupControl>
                    </div>
                </OEPopover>
            </React.Fragment>
        );
    }

    onHelpBtnPressed()  {
        if(this.props.appComponent)    this.props.appComponent.uiLayer.manualView.setOpen(true, {link: OEManualViewLinks.userObject});
    }

    onEnableSwitchChanged() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerUserObject().setEnabled(!this.state.enabled, true, 0.333);
    }

    onEditSwitchChanged() {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerUserObject().enableEditing(!this.state.enableEdit);
    }

    onAddRemoveSwitchChanged() {
        if(!this.oe.isReady()) return;
        if(this.oe.sharedInterface.getUIControllerUserObject().isEditingEnabled()) {
            this.oe.sharedInterface.getUIControllerUserObject().enableEditingAddRemove(!this.state.enableAddRemove);
        }
    }

    onGeometrySelected(type) {
        if(!this.oe.isReady()) return;
        this.oe.sharedInterface.getUIControllerUserObject().setGeometryType({value: type});
    }
}

OEUserObjectController.defaultProps = {
    moduleId: '',
    target: '',
    config: OEDefaultConfigFactory.userObjectController()
};

OEUserObjectController.propTypes = {
    moduleId: PropTypes.string,
    config: PropTypes.shape({
        enabled: PropTypes.bool,
        showHelpBtn: PropTypes.bool
    }).isRequired
};

export default connectAppEnv((env) => {
    const ui = env.config.module.uiLayerConfig;
    return {
        appComponent: env.component,
        config: OEDefaultConfigFactory.combineShowHelpState(ui.widgetConfig.userObjectController, ui.widgetConfig.showHelp, ui.manualView.links, OEManualViewLinks.userObject)
    }
})(withUILevel(OEUserObjectController));